import styled from 'styled-components'

import { MEDIA_QUERY } from '../../../../styles'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 20px;
  @media ${MEDIA_QUERY.TABLET} {
    flex-direction: column;
    gap: 10px;
  }
  @media ${MEDIA_QUERY.MOBILE} {
    flex-direction: column;
    gap: 10px;
    width: clamp(250px, 70%, 320px);
    margin: auto;
  }
`

export const Label = styled.label<{ $labelSize?: number }>`
  text-align: left;
  width: ${({ $labelSize }) => (!$labelSize ? 'auto' : $labelSize + 'px')};
  font-weight: 600;
  > label {
    display: inline;
  }
  #tip-container {
    position: relative;
    top: 5px;
    left: -10px;
    display: inline-block;
  }
  @media ${MEDIA_QUERY.MOBILE} {
    display: block;
    width: 100%;
    text-align: center;
    #tip-container {
      display: none;
    }
  }
`

export const Content = styled.div`
  flex-grow: 2;
  text-align: left;
  @media ${MEDIA_QUERY.MOBILE} {
    width: 100%;
  }
`
